export default {
    workOrder_customerDetail_workOrders: "Órdenes de Trabajo",
    workOrder_customerDetail_contacts: "Contactos",
    workOrder_customerDetail_locations: "Ubicaciones",
    workOrder_customerDetail_name: "Nombre",
    workOrder_customerDetail_ein: "EIN",
    workOrder_customerDetail_address: "Dirección",
    workOrder_customerDetail_tags: "Etiquetas",
    workOrder_customerDetail_customers: "Clientes",
    workOrder_customerDetail_edit: "Editar",
    workOrder_customerDetail_delete: "Eliminar",
    workOrder_customerDetail_email: "Correo",
    workOrder_customerDetail_phone: "Teléfono",
    workOrder_customerDetail_hideDescription: "Ocultar Descripción",
    workOrder_customerDetail_showDescription: "Mostrar Descripción",
}